<template>
    <van-dialog
        v-model="dialogObj.showTipsRisk" 
        class="commonTip"
        :show-confirm-button="dialogObj.BooleanConfirm"
        :show-cancel-button="dialogObj.BooleanCancel"
        confirm-button-color="#E12817"
        cancel-button-color="#666666"
        :confirm-button-text="dialogObj.dynamicConfirmText"
        :cancel-button-text="dialogObj.dynamicCancelText"
        @confirm="confirmTips"
        @cancel="cancelDialog"
        >
        <div class="title">温馨提示</div>
        <div class="stopListContent">
            {{dialogObj.dynamicTipsContent}}
        </div>
      </van-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    dialogObj:{
      type:Object
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapState(["newPersonalAccount", "deviceId","deviceInfo"]),
  },
  // 监听返回
  watch: {
   
  },
  created() {},
  mounted() {
    this.title = this.$store.state.title
  },
  methods:{
     //弹框确认回调
     confirmTips(){
        if(this.dialogObj.tipsCode === 80080){
          let {groupCommonId,orgCommonId,company,userType,shlxLoginPersonType = ''} = this.newPersonalAccount
          let param = {
            groupCommonId,
            orgCommonId,
            companyId:company,
            loginPersonType:shlxLoginPersonType,
            userType
          }
          this.$post(this.$api.getPersonalCenterInfo, param,).then((res)=>{
            if(res.code === 10000){
              this.$store.commit("routerJump", "shoppingCartModule");
              let obj = {
                ...this.newPersonalAccount,
                companyId:company,
                isOpenCompanyAccount:res.data.isOpenCompanyAccount
              }
              this.$store.commit("getPersonalAccount", obj);
              this.$store.commit("changeOpenAccount", obj);
              this.$router.push("/accountInfo");
              localStorage.setItem('localRouter','shoppingModule')
            }else{
              this.$toast(res.message)
            }
          })
            // let params = {
            //   requestType: "start_new_H5_page_by_native_app",
            //   requestData: {
            //     // nextPageUrl: String(`${process.env.VUE_APP_API_URL}:8001/${page}`),
            //     nextPageUrl: String(`http://192.168.186.41:8081/accountInfo`),
            //     nextPageData: {},
            //     titleName:String(name),
            //   },
            // };
            // if (this.$store.state.getHeadInfo.company == 1) {
            //   if (this.IOS.ios()) {
            //     window.webkit.messageHandlers.requestEventData.postMessage(params);
            //   } else {
            //     window.android.requestEventData(JSON.stringify(params));
            //   }
            // }
        }
        this.cancelDialog()
    },
    cancelDialog(){
      const current = {
        status:'0'
      }
      this.$store.commit('changeVerifyStatus',current)
    }
  }
};
</script>

<style scoped lang="scss">
.commonTip {
  color: #333;
  .title {
    font-size: 0.18rem;
    font-weight: bold;
    padding: 0.24rem 0 0;
    text-align: center;
  }
  .stopListContent {
    font-size: 0.15rem;
    padding: 0.08rem 0.16rem 0.24rem;
    text-align: left;
  }
  /deep/.van-hairline--top::after {
    border-color: #e5e5e5;
  }
}
</style>